import { useAuth } from "../../context/AuthContext";
import PageLoader from "../../ui/PageLoader";
import DisableAccountComponent from "./DisableAccComponent";
import AdminDashboard from "./AdminDashboard";

// ProtectedRoute has already loaded the user, so this only picks the right view.
const Dashboard = () => {
  const { currentUser } = useAuth();

  if (!currentUser) return <PageLoader />;
  return currentUser.role === "Manager" ? <AdminDashboard /> : <DisableAccountComponent />;
};

export default Dashboard;
